<template>
  <div class="signature">
    <nav class="navigation clearfix">
      <tabs :tabs="tabs" class="tabs" @selected="id => (tabId = id)" />
    </nav>
    <signature-draw
      v-if="tabId === 'draw'"
      :labels="labels"
      :can-sign="canSign"
    />
    <signature-type
      v-if="tabId === 'type'"
      :labels="labels"
      :can-sign="canSign"
    />
    <signature-upload
      v-if="tabId === 'upload'"
      :labels="labels"
      :can-sign="canSign"
    />
  </div>
</template>

<script>
import { Tabs } from 'vue-bootstrap';
import SignatureDraw from './SignatureDraw';
import SignatureType from './SignatureType';
import SignatureUpload from './SignatureUpload';

export default {
  components: {
    Tabs,
    SignatureDraw,
    SignatureType,
    SignatureUpload
  },
  props: {
    labels: {
      type: Object,
      required: true
    },
    canSign: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tabId: 'draw',
      tabs: [
        { id: 'draw', name: this.labels.draw },
        { id: 'type', name: this.labels.type },
        { id: 'upload', name: this.labels.upload }
      ]
    };
  }
};
</script>

<style scoped>
.tabs {
  border-bottom: 0;
}
</style>
